<div *ngIf="product">
  <div class="productPage" [class.productPage--sold]="product.sold">
    <div class="productPage__top innerContainer" *ngIf="product">
      <vc-breadcrumb
        *ngIf="breadcrumbList"
        class="productPage__top__breadcrumb d-none d-md-block"
        [items]="breadcrumbList"
      ></vc-breadcrumb>
      <div class="productPage__top__title">
        <vc-product-main-heading [product]="product"></vc-product-main-heading>
        <vc-product-tags [tags]="product?.tags"></vc-product-tags>
      </div>
      <div class="productPage__top__image">
        <vc-carousel-images
          [pictures]="product?.pictures"
          [defaultAlt]="product.name + ' ' + product.brand?.name"
          [currentSlide]="0"
          [openDialogEnabled]="true"
          [showArrowsOnBigImg]="false"
        ></vc-carousel-images>
        <vc-product-image-actions-bar
          [product]="product"
          [isLiked]="isLiked"
          (scrollTo)="scrollTo($event)"
        ></vc-product-image-actions-bar>
      </div>
      <div class="productPage__top__infos">
        <vc-product-details
          [user]="user"
          [userRole]="userRole"
          [product]="product"
          [negotiation]="negotiation"
          [shipping]="shipping"
          [idSite]="idSite"
          [regionCode]="regionCode"
          [sizeGuide]="sizeGuide"
          [shippingVoucherPath]="shippingVoucherPath"
          [directShippingEligible]="directShippingEligible"
          (openConditionGuideModal)="openConditionGuideModal()"
        ></vc-product-details>
      </div>
    </div>

    <nav class="productPage__menu">
      <!--
        <div class="productMenu innerContainer">
          <button class="productMenu__link active" (click)="scrollTo('block_description')" i18n="@@PRODUCT.MENU.DESCRIPTION">Details</button>
          <button class="productMenu__link" *ngIf="similarProducts" (click)="scrollTo('block_discover')" i18n="@@PRODUCT.MENU.DISCOVER">You might also like</button>
          <button class="productMenu__link" (click)="scrollTo('block_comments')" i18n="@@PRODUCT.MENU.DISCUSSIONS">Comments</button>
          <button class="productMenu__link" *ngIf="toWearWithProducts" (click)="scrollTo('block_wearwith')" i18n="@@PRODUCT.MENU.WEAR_WITH">You might wear it with</button>
        </div>
      -->
    </nav>
    <section class="productPage__moreDetails" #block_description>
      <vc-product-description
        [user]="user"
        [product]="product"
        [shipping]="shipping"
        [sizeGuide]="sizeGuide"
        (openCommentsModal)="scrollTo('block_comments')"
        (openConditionGuideModal)="openConditionGuideModal()"
        [canReportProducts]="user?.productReporter"
        [directShippingEligible]="directShippingEligible"
      ></vc-product-description>
    </section>
    <section
      class="productPage__discover"
      #block_discover
      *ngIf="similarProducts && similarProducts.length > 0"
      itemscope
      itemtype="https://schema.org/isSimilarTo"
    >
      <vc-product-section-carousel
        i18n-title="@@PRODUCT.DISCOVER.TITLE"
        title="You may also like"
        (carouselProductClick)="trackProductCrossSellClick($event)"
        [productList]="similarProducts"
        [seoContext]="['productPage', 'similarProducts']"
      ></vc-product-section-carousel>
    </section>
    <section *ngIf="!isServer" class="productPage__discussions" #block_comments>
      <div class="innerContainer" vcObserve (enterViewport)="showDiscussion = true">
        <h2 class="vc-title-m productPage__discussions__title" i18n="@@PRODUCT.DISCUSSIONS.TITLE">Comments</h2>
        <vc-discussions
          *ngIf="product?.id && showDiscussion === true"
          [commentType]="'product'"
          [product]="product"
          [negotiations]="negotiationsList"
          [showLikeFunctionality]="false"
        ></vc-discussions>
      </div>
    </section>
    <section class="productPage__wearwith" #block_wearwith *ngIf="toWearWithProducts">
      <vc-product-section-carousel
        i18n-title="@@PRODUCT.WEAR_WITH.TITLE"
        title="You might wear it with"
        [productList]="toWearWithProducts"
      ></vc-product-section-carousel>
    </section>
    <section class="productPage__seenproducts" #block_seenproducts *ngIf="seenProducts && seenProducts.length > 0">
      <vc-product-section-carousel
        i18n-title="@@PRODUCT.RECENTLY_SEEN.TITLE"
        title="Recently viewed"
        [productList]="seenProducts"
      ></vc-product-section-carousel>
    </section>
    <vc-product-categories-suggestions
      class="productPage__categories"
      [product]="product"
    ></vc-product-categories-suggestions>
  </div>
  <ngx-json-ld [json]="schemas"></ngx-json-ld>
</div>
